module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>'+
((__t=(t('drag-n-drop::add-to-set')))==null?'':_.escape(__t))+
'</h3>\n<ul id="navigationSetsList">\n</ul>';
}
return __p;
};